import { useEffect } from 'react';
import {
  LDClient,
  LDSingleKindContext,
  useLDClient,
} from 'launchdarkly-react-client-sdk';

import useUserData from 'approot/shared/user/user-data';
import { getUserData } from 'approot/shared/api/auth/auth';
import { getStudentData } from 'approot/student-class-to-do/student-class-to-do.utils';
import {
  getStudentClassInfo,
  getStudentUserData,
} from 'approot/shared/api/auth/student-user-auth';
import { guessCurrentRegion } from 'approot/shared/region/region.utils';

export const GUEST_KEY = 'guest';
export const USER_KIND = 'user';

export function initialiseLdUser(
  user?: {
    id: number;
    featureFlags: {
      groups: string[];
    };
  } | null
): LDSingleKindContext {
  const country = guessCurrentRegion();
  const flags = user?.featureFlags;
  if (flags) {
    return {
      kind: USER_KIND, // this is the default value if not set
      key: user?.id.toString(),
      groups: flags.groups,
      country,
    };
  }

  return {
    kind: USER_KIND, // this is the default value if not set
    key: GUEST_KEY,
    country,
  };
}

export function getLaunchDarklyUserContext() {
  // These all read from local storage
  const userData = getUserData();
  const studentClassInfo = getStudentClassInfo();
  const studentUserData = getStudentUserData();
  const studentClassData = getStudentData();

  if (studentClassData?.teacher) {
    return {
      id: studentClassData.teacher.id,
      featureFlags: studentClassData.teacher.featureFlags,
    };
  }

  if (studentClassInfo?.classId && studentUserData?.studentUser) {
    const currentClass = studentUserData.studentUser.currentClasses.find(
      c => c.id === studentClassInfo.classId
    );
    if (currentClass?.teacherId) {
      return {
        id: currentClass?.teacherId,
        featureFlags: currentClass?.featureFlags,
      };
    }
  }

  if (userData?.user) {
    return {
      id: userData.user.id,
      featureFlags: userData.user.featureFlags,
    };
  }
}

export function handleUserChangeIfNeeded(ldClient: LDClient | undefined) {
  if (ldClient) {
    const ldUser = ldClient.getContext();

    if (ldUser) {
      const newUser = initialiseLdUser(getLaunchDarklyUserContext());
      if (ldUser.key !== newUser.key) {
        console.log('changing ld user to', newUser);
        ldClient.identify({
          ...newUser,
        });
      }
    }
  }
}

const GlobalLaunchDarkly = () => {
  const { isSignedIn, isStudentSignedIn } = useUserData();
  const ldClient = useLDClient();

  useEffect(() => {
    handleUserChangeIfNeeded(ldClient);
  }, [isSignedIn, isStudentSignedIn, ldClient]);

  return <></>;
};

export default GlobalLaunchDarkly;
